export default __webpack_public_path__ + "static/media/your-online-b2b-store-vegshelf-marketplace.21fe9802.png";